import React from "react";
import { Play } from "lucide-react";

export default function MovieCard({ item, onClick }) {
  return (
    <button
      data-testid={`movie-card-${item.id}`}
      onClick={onClick}
      className="movie-card relative shrink-0 w-[180px] md:w-[200px] aspect-[2/3] rounded-xl overflow-hidden bg-surface text-left group"
    >
      <img
        src={item.image}
        alt={item.title}
        loading="lazy"
        className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
        onError={(e) => { e.currentTarget.style.background = "#1a1a1f"; e.currentTarget.style.opacity = "0.4"; }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent opacity-90 group-hover:opacity-100 transition" />

      <div className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-brand/90 text-white text-[10px] font-bold uppercase tracking-wide">
        {item.type}
      </div>

      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
        <div className="w-12 h-12 rounded-full bg-brand flex items-center justify-center shadow-2xl shadow-brand/40">
          <Play className="w-5 h-5 text-white fill-white" />
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-3">
        <p className="text-[10px] uppercase tracking-widest text-brand-light font-bold">{item.type}</p>
        <p className="text-white text-sm font-semibold leading-tight line-clamp-2">{item.title}</p>
      </div>
    </button>
  );
}
